import { render, staticRenderFns } from "./Index_v1.vue?vue&type=template&id=6446d8d4&scoped=true&"
import script from "./Index_v1.vue?vue&type=script&lang=js&"
export * from "./Index_v1.vue?vue&type=script&lang=js&"
import style0 from "./Index_v1.vue?vue&type=style&index=0&id=6446d8d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6446d8d4",
  null
  
)

export default component.exports